import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTimeSheetComponent } from './datetime-sheet.component';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [DateTimeSheetComponent],
  imports: [
    TranslateModule,
    FormsModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    QRCodeModule
  ],
  exports: [DateTimeSheetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DateTimeSheetModule { }
